// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  url: 'https://demo.odep.saferoads.ph',
  production: true,

  luxandURL: 'https://api.luxand.cloud',

  cmsServiceURL: 'https://odep-saferoadsph-reports-service-legacy-demo.azurewebsites.net/api/v1',
  userServiceURL: 'https://odep-saferoadsph-user-service-legacy-demo.azurewebsites.net/api/v1',
  //userServiceURL: 'http://localhost:9090/api/v1',
  courseServiceURL:
    'https://odep-saferoadsph-module-service-legacy-demo.azurewebsites.net/api/v1',
  paymentServiceURL:
    'https://odep-saferoadsph-payment-service-legacy-demo.azurewebsites.net/api/v1',
  mayaWebHookServiceURL:
    'https://odep-saferoadsph-payment-service-legacy-demo.azurewebsites.net/api/v1/maya',
  dsControlPanelURL:'https://demo.ad.saferoads.ph/',

  azureFaceApiEndPoint: 'https://saferoadsph.cognitiveservices.azure.com/',

  paymongoURL: 'https://api.paymongo.com/v1/',

  paymayaURL: 'https://pg.maya.ph/checkout/v1/', 

  recaptchaSiteKey: '6Ld6tE0tAAAAAAzSAd6n07LSSQqPLVY7zGf5FKsS',
  //recaptchaSiteKey: '',

  faceApiCalibration: {
    recognitionThreshold: 0.58,
    livenessScoreThreshold: 0.72,
    livenessMinBoxAreaRatio: 0.09,
    livenessMinInterEyeDistance: 23,
    livenessMinNoseToMouthDistance: 10,
  },

  passwordPolicy: {
    useMockApi: true,
    minLength: 12,
    maxLength: 32,
    requireUppercase: true,
    requireLowercase: true,
    requireNumber: true,
    requireSpecialCharacter: true,
    specialCharacterPattern: '[^A-Za-z0-9]',
    enableHistoryCheck: false,
    preventReuseCount: 5,
    enableExpirationCheck: false,
    expireAfterDays: 90,
  },


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
